/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useDropzone } from "react-dropzone";

import { useDispatch, useSelector } from "react-redux";

import { getLabelMessage } from "../../../../const/labelService";

import {
  DragZoneContainer,
  Thumb,
  Img,
  Label,
  MainText,
  SecondaryText,
  TextContainer,
  DragWrapper,
  IconsContainer,
  IconContainer,
  IconText,
  PreviewContainer,
  PreviewHeader,
  PreviewBody,
  PreviewIconContainer,
  PreviewTextContainer,
  PreviewTitle,
  PreviewFileType,
  PreviewIcon,
  PreviewDetailsContainer,
  PreviewDeleteFile,
  PreviewDetailsFile,
} from "./DropZoneImage.style";
import { SelectError } from "../select/Select.style";
import imageIcon from "../../../../assets/svg/imageIcon.svg";
import videoIcon from "../../../../assets/svg/videoIcon.svg";
import fileIcon from "../../../../assets/svg/fileIcon.svg";
import getWeightFile from "../../../../utils/getWeightFile";
import { setTempFileAsSelected } from "../../../../redux/multimediaDuck";
import CONSTANTS from "../../../../const/constants";
import PDFViewer from "./pdfViewer/PdfViewer.component";
import PdfPreview from "../../../album/filePreview/pdfPreview/PdfPreview.component";
import useFileUpload from "../../../../hooks/useFileUpload";

const DropZoneImage = ({
  prepareFiles,
  defaultFile = null,
  label = null,
  mainText = null,
  disabled = false,
  secondaryText = null,
  thirdText = null,
  maxSize = 15000000,
  minWidth = 512,
  maxWidth = 1024,
  square = true,
  acceptedFilesTypes = ["image/*", "video/mp4"],
  filterFiles = false,
  fullSize = false,
  showBorder = false,
  onDrop,
  newTheme = false,
  importContacts,
  templateMedia,
  isPreview,
  isSelectTemplate,
}) => {
  const dispatch = useDispatch();
  const [files, setFiles] = useState([]);
  const [file, setFile] = useState([]);
  const [fileType, setfileType] = useState("");
  // const [error, setError] = useState("");
  const selectedFiles = useSelector((state) => state.multimedia?.selectedFile);
  const fileUrl = selectedFiles?.length > 0 ? selectedFiles[0]?.url : null;
  const { isLoading, error, setError, uploadedFiles, handleDrop } =
    useFileUpload(onDrop, maxSize);
  const labels = [
    "dropZoneFormatError",
    "dragFilesError",
    "dragFilesSizeError",
  ];
  const lbls = getLabelMessage(labels);

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    ...(filterFiles && { accept: acceptedFilesTypes }),
    multiple: true,
    onDragEnter: () => {
      console.log("onDragEnter!!!!!!!!!!!!");
      setError("");
    },
    onDropRejected: (rejectedFiles) => {
      console.log("onDropRejected!!!!!!!!!!!!");

      let rejectedFilesText = "";
      rejectedFiles.forEach((rejectedFile, index) => {
        console.log("rejectedFile: ", rejectedFile);
        rejectedFilesText += `${
          rejectedFile?.name?.length > 20
            ? rejectedFile?.name.slice(0, 10) + "..."
            : rejectedFile?.name
        }
        ) }${
          rejectedFiles?.length !== 1 && rejectedFiles?.length - 1 !== index
            ? ", "
            : ""
        } `;
      });
      console.log("rejectedFilesText: ", rejectedFilesText);
      setError(
        (previousError) =>
          `${lbls.dragFilesError(rejectedFilesText, rejectedFiles?.length)}`
      );
    },
    onDrop: (acceptedFiles) => {
      console.log("acceptedFiles: ", acceptedFiles);
      handleDrop(acceptedFiles, false);
    },
    disabled,
  });

  useEffect(() => {
    if (defaultFile) {
      const extension = defaultFile.split(".").pop();
      fetch(defaultFile)
        .then((res) => res.blob())
        .then((blob) => {
          const objectURL = URL.createObjectURL(blob);
          const defaultImage = new File([objectURL], `company.${extension}`, {
            type: blob.type,
          });
          Object.assign(defaultImage, {
            preview: objectURL,
            path: defaultFile,
            uploaded: true,
          });
          setFiles([defaultImage]);
        })
        .catch((e) => console.error(e));
    }
  }, [defaultFile]);

  useEffect(() => {
    console.log("selectedFiles: ", selectedFiles);
    if (selectedFiles?.length === 0) setError("");
    const file = selectedFiles?.length > 0 && selectedFiles[0];
    console.log("FILE: ", file);
    if (file) {
      switch (file.mimeType) {
        case "image/jpeg":
          setfileType("JPG");
          break;
        case "image/png":
          setfileType("PNG");
          break;
        case "video/mp4":
          setfileType("MP4");
          break;
        case "application/pdf":
          console.log("PDF");
          setfileType("PDF");
          console.log(fileType);
          break;
        case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
          setfileType(CONSTANTS.FILE_TYPE_XLSX);
          break;
        case "application/vnd.ms-excel":
          setfileType(CONSTANTS.FILE_TYPE_XLS);
          break;
        case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
          setfileType(CONSTANTS.FILE_TYPE_PPTX);
          break;
        case "application/vnd.ms-powerpoint":
          setfileType(CONSTANTS.FILE_TYPE_PPT);
          break;
        case "application/x-rar-compressed":
          setfileType(CONSTANTS.FILE_TYPE_ZIP);
          break;
        case "text/csv":
          setfileType(CONSTANTS.FILE_TYPE_CSV);
          break;
        case "text/plain":
          setfileType(CONSTANTS.FILE_TYPE_TXT);
          break;
        case "application/msword":
          setfileType(CONSTANTS.FILE_TYPE_DOC);
          break;
        case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
          setfileType(CONSTANTS.FILE_TYPE_DOCX);
          break;

        default:
          console.log("FILE_TYPE_GENERIC");
          break;
      }
      setFile(file);
      console.log("type: ", file.mimeType);
      console.log("type: ", fileType);
    }
    console.log("FILE_st: ", file);
    console.log("fileType_st: ", fileType);
    console.log("fileUrl: ", fileUrl);
  }, [selectedFiles?.length]);

  useEffect(
    () => () => {
      files.forEach((file) => URL.revokeObjectURL(file.preview));
    },
    [files]
  );
  const { fileSize, size } = getWeightFile(
    selectedFiles?.length > 0 && selectedFiles[0]?.weight
  );
  return (
    <>
      {label && <Label newTheme={newTheme}>{label}</Label>}
      <DragWrapper
        newTheme={newTheme}
        fullSize={fullSize}
        importContacts={importContacts}
        templateMedia={templateMedia}
        image={fileType === "JPG" || fileType === "PNG"}
        doc={
          fileType === CONSTANTS.FILE_TYPE_XLSX ||
          fileType === CONSTANTS.FILE_TYPE_PPTX
        }
      >
        {templateMedia && selectedFiles?.length > 0 && (
          <>
            <PreviewContainer isSelectTemplate={isSelectTemplate}>
              {(fileType === "JPG" || fileType === "PNG") && (
                <PreviewHeader
                  image
                  style={{
                    backgroundImage: `url(${fileUrl})`,
                    backgroundSize: "contain",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                  }}
                />
              )}
              {fileType === "MP4" && (
                <PreviewHeader>
                  <video controls width="100%" height="100%">
                    <source src={fileUrl} type="video/mp4" />
                    {/* <source src="ruta-del-video.webm" type="video/webm" /> */}
                    <p>Tu navegador no admite el elemento video.</p>
                  </video>
                </PreviewHeader>
              )}

              {fileType === "PDF" && (
                <PreviewHeader>
                  <PdfPreview url={fileUrl} templateMedia />
                </PreviewHeader>
              )}

              <PreviewBody>
                <PreviewIconContainer>
                  {(fileType === "JPG" || fileType === "PNG") && (
                    <PreviewIcon src={imageIcon} />
                  )}
                  {fileType === "MP4" && <PreviewIcon src={videoIcon} />}
                  {fileType === "PDF" && <PreviewIcon src={fileIcon} />}
                </PreviewIconContainer>

                <PreviewTextContainer>
                  <PreviewTitle wrap={file[0]?.name?.length > 40}>
                    {file[0]?.name}
                  </PreviewTitle>
                  <PreviewFileType>{`Archivo ${fileType}`}</PreviewFileType>
                </PreviewTextContainer>

                <PreviewDetailsContainer>
                  <PreviewDeleteFile
                    onClick={() => {
                      setError("");
                      dispatch(setTempFileAsSelected([]));
                    }}
                  >
                    Eliminar
                  </PreviewDeleteFile>
                  <PreviewDetailsFile>
                    {fileSize}
                    {size}
                  </PreviewDetailsFile>
                </PreviewDetailsContainer>
              </PreviewBody>
            </PreviewContainer>
            <SelectError>{error}</SelectError>
          </>
        )}
        {selectedFiles?.length === 0 && (
          <>
            <DragZoneContainer
              {...getRootProps({ isDragActive, isDragAccept, isDragReject })}
              disabled={disabled}
              fullSize={fullSize}
              showBorder={showBorder}
              importContacts={importContacts}
              templateMedia={templateMedia}
            >
              {files.map((file) => (
                <Thumb key={file.name}>
                  <Img src={file.preview} />
                </Thumb>
              ))}
              <TextContainer
                fullSize={fullSize}
                importContacts={importContacts}
                templateMedia={templateMedia}
              >
                {importContacts && (
                  <MainText importContacts>{mainText}</MainText>
                )}

                {templateMedia && (
                  <>
                    <IconsContainer>
                      <IconContainer style={{ marginRight: "45px" }}>
                        <img src={imageIcon} alt="imageIcon" />
                        <IconText>Imagen</IconText>
                      </IconContainer>
                      <IconContainer style={{ marginRight: "45px" }}>
                        <img src={videoIcon} alt="videoIcon" />
                        <IconText>Video</IconText>
                      </IconContainer>
                      <IconContainer>
                        <img src={fileIcon} alt="fileIcon" />
                        <IconText>Documento</IconText>
                      </IconContainer>
                    </IconsContainer>
                    <MainText templateMedia>{mainText}</MainText>
                  </>
                )}

                {mainText && !importContacts && !templateMedia && (
                  <MainText newTheme={newTheme}>{mainText}</MainText>
                )}
                {secondaryText && (
                  <SecondaryText newTheme={newTheme}>
                    {secondaryText}
                  </SecondaryText>
                )}
                {thirdText && (
                  <SecondaryText newTheme={newTheme}>{thirdText}</SecondaryText>
                )}
              </TextContainer>
              <input {...getInputProps()} />
            </DragZoneContainer>
            <SelectError>{error}</SelectError>
          </>
        )}
      </DragWrapper>
    </>
  );
};

DropZoneImage.propTypes = {
  prepareFiles: PropTypes.func.isRequired,
  defaultFile: PropTypes.string,
  label: PropTypes.string,
  mainText: PropTypes.string,
  disabled: PropTypes.bool,
  secondaryText: PropTypes.string,
  maxSize: PropTypes.number,
  minWidth: PropTypes.number,
  maxWidth: PropTypes.number,
  fullSize: PropTypes.bool,
  showBorder: PropTypes.bool,
  acceptedFilesTypes: PropTypes.array,
  newTheme: PropTypes.bool,
};

DropZoneImage.defaultProps = {
  newTheme: false,
};

export default DropZoneImage;
